export default __webpack_public_path__ + "static/media/bath.5fa73344.png";